module.exports = __webpack_public_path__ + "media/images/facebook-image-438f163ee8e8beb4b4c8636ddaf26cef.png";